<template>
    <div class="landings" v-can="'settings_landing.access'" v-if="isMounted">
        <ds-filter
            :data="landings"
            :fields="filterFields"
            @resultFilter="resultFilter"
        ></ds-filter>

        <ds-table
            :data="dataLandingsFilter"
            :heads="heads"
            spacer
            search
        >
            <template v-slot:header>
                <vs-button
                    v-can="'settings_landing.create'"
                    @click="openPopupAdd(null)"
                    class="mr-4 whitespace-no-wrap"
                    color="primary"
                    type="border"
                    v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                >
                    {{$t('buttons.Add_landing')}}
                </vs-button>
            </template>

            <template v-slot:landing="{landing}">
                <div>
                    <div class="mb-1">{{landing.name}}</div>
                    <div class="flex items-center" v-if="landing.preview_url">
                        <a :href="landing.preview_url" target="_blank" class="link">{{landing.preview_url}}</a>
                        <vs-icon
                            class="cursor-pointer ml-2 p-1"
                            :class="{disabled: buffer.includes(landing.preview_url)}"
                            color="primary"
                            v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                            @click="copyLing(landing.preview_url)"
                        ></vs-icon>
                    </div>
                    <div class="flex items-center" v-if="landing.source_url">
                        <a :href="landing.source_url" target="_blank" class="link">{{landing.source_url}}</a>
                        <vs-icon
                            class="cursor-pointer ml-2 p-1"
                            :class="{disabled: buffer.includes(landing.source_url)}"
                            color="primary"
                            v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                            @click="copyLing(landing.source_url)"
                        ></vs-icon>
                    </div>
                </div>
            </template>

            <template v-slot:language="{language}">
                <p v-if="!language.language" class="lang product-name font-medium truncate">-</p>
                <div v-else class="lang product-name font-medium truncate flex items-center">
                    <flag width="25" type="language" :iso="language.language"/>
                    <div class="text-xs ml-2">
                        <div>
                            <span style="color: gray; font-size: 9px;">{{languageFilterRName(language.language)}}</span>
                        </div>
                        <div>{{language.language.toUpperCase()}}</div>
                    </div>
                </div>
            </template>

            <template v-slot:status="{status}">
                <vs-switch v-can="'settings_landing.destroy'" @click.stop.prevent="changeLandingStatus($event, status)" :checked="Boolean(status.is_active)" color="success" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
                <vs-switch v-can:show="'settings_landing.destroy'" disabled :checked="Boolean(status.is_active)" color="success" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
            </template>

            <template v-slot:actions="{actions}">
                <div class="flex">
                    <vs-button v-can="'settings_landing.update'" class="mr-3" @click.stop.prevent="openPopupEdit(actions.id)" radius color="primary" type="flat" v-bind="$iconData('icon-edit', 'fi-rr-file-edit')" v-tooltip="$t('modals.Edit_landing')"></vs-button>
                    <vs-button v-can:show="'settings_landing.update'" class="mr-3" disabled radius color="primary" type="flat" v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"></vs-button>
                </div>
            </template>
        </ds-table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventBus from "@/store/eventBus"
import ErrorHandler from '@/utils/errorHandler'
import {flag} from '@/utils/mixins'
import {copy} from "@/utils/utils"

export default {
    name: 'Landings',
    mixins: [flag],
    data() {
        return {
            isMounted: false,
            currentLandings: null,
            dataLandings: [],
            dataLandingsFilter: [],
            filterFields: [
                {name: 'settings.Landing_status', type: 'select', label: 'active_name', field: 'active_name'},
                {name: 'global.Language', type: 'select', label: 'full_language', field: 'full_language'},
                {name: 'global.Offer', type: 'select', label: 'offer_name', field: 'offer_id'},
            ],
            heads: [
                {name: 'global.id', key: 'id', sortKey: 'id', value: 'id', display: true, width: '40px'},
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'landing', display: true},
                {name: 'global.Language', key: 'language', sortKey: 'language', value: 'language', display: true},
                {name: 'global.Offer', key: 'offer', sortKey: 'offer_name', value: 'offer_name', display: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'status', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ],
            buffer: []
        }
    },

    computed: {
        ...mapGetters(['landings', 'languages']),
    },

    methods: {
        ...mapActions(['GET_ALL_LANDINGS', 'UPDATE_STATUS_LANDINGS', 'GET_OFFER_LIST']),

        copyLing(link) {
            if (!this.buffer.includes(link)) {
                let result = {}

                try {
                    copy(link)
                    result.text = link
                    result.status = 'success'
                    result.icon = 'icon-check'
                    result.title = this.$t('notification.success')

                    this.buffer.push(link)
                } catch (e) {
                    result.text = this.$t('notification.errorMessage')
                    result.status = 'danger'
                    result.icon = 'icon-alert-circle'
                    result.title = this.$t('notification.error')
                }

                if (Object.keys(result).length) {
                    this.$vs.notify({
                        title: result.title,
                        text: result.text,
                        color: result.status,
                        iconPack: 'feather',
                        icon: result.icon
                    })
                }

                setTimeout(() => {
                    this.buffer = this.buffer.filter(item => item !== link)
                }, 2000)
            }
        },

        resultFilter(data) {
            this.dataLandingsFilter = data
        },

        languageFilterRName(lang) {
            const data = this.languages.find(el => el.iso_2 === lang.toUpperCase())

            if (data) {
                return data.language
            }
        },

        changeLandingStatus (e, data) {
            e.preventDefault()
            this.currentLandings = data.id;

            this.loadingEl = e.target.parentNode
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: data.is_active ? this.$t('confirm.deactivateLanding') : this.$t('confirm.activateLanding'),
                accept: this.sendStatus,
                acceptText: data.is_active ?this.$t('buttons.Deactivate') : this.$t('buttons.Activate'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async sendStatus() {
            this.$vs.loading({
                background: 'rgba(255,255,255,0.75)',
                color: 'primary',
                container: this.loadingEl,
                scale: +'0.45'
            })

            try {
                await this.UPDATE_STATUS_LANDINGS({id: this.currentLandings })
                this.$vs.loading.close(this.loadingEl)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        openPopupAdd(id) {
            EventBus.$emit('emitPopupEvent', {type: 'addLanding', name: this.$t('buttons.Add_landing'), ids: {id}})
        },

        openPopupEdit(id) {
            EventBus.$emit('emitPopupEvent', {type: 'editLanding', name: this.$t('modals.Edit_landing'), ids: {id}})
        },

    },

    async mounted() {
        try {
            await this.GET_OFFER_LIST()
            await this.GET_ALL_LANDINGS()

            this.isMounted = true
        } catch (e) {
            new ErrorHandler(e).send
        }
    },
    destroyed(){
        this.$store.commit('SET_LIST', [])
        this.$store.commit('SET_LANDINGS', {landings: [], languages: []})
    }
}
</script>

<style lang="scss">
.landings {
    .disabled {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }

    .link {
        white-space: nowrap;
        color: #bfbfbf;
        font-size: .83rem;
        transition: all .25s ease;
        &:hover {
            text-decoration: underline;
            color: rgba(var(--vs-primary), 1);
            transition: all .25s ease;
        }
    }
}
</style>
